import { Route } from 'react-router'
import { observer } from 'mobx-react-lite'
import { RoutesWithNotFound } from 'entities/ExportRouters/ui/RoutesWithNotFound'
import { AddOnsAccessLayout } from 'pages/settings/pages/addOns/layout/AddOnsAccessLayout'
import { AddOnsPageLayout } from 'pages/settings/pages/addOns/layout/AddOnsPageLayout'
import { AddOnsView } from 'pages/settings/pages/addOns/AddOnsView'

export const AddOnsRouter = observer(() => {
  return (
    <RoutesWithNotFound>
      <Route element={<AddOnsAccessLayout />}>
        <Route element={<AddOnsPageLayout />}>
          <Route index element={<AddOnsView />} />
        </Route>
      </Route>
    </RoutesWithNotFound>
  )
})
